import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TableContainer,
  Paper,
  Breadcrumbs,
  Link,
  Card,
  CardContent,
  Chip,
  Grid,
  Autocomplete,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import {
  Folder as FolderIcon,
  ArrowForwardIos,
  Visibility,
} from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { buttonStyle, CLIENT, CONSENT_PARTY, themeStyles } from "../constants";

import { motion } from "framer-motion";
import axiosInstance from "../components/AxiosInstance";
import { API_BASE_URL, dataGridStyle } from "../constants";
import LoadingIndicator from "../scenes/Loader";
import GoalDetailsDialog from "./ViewGoal";
import { useLocation, useNavigate } from "react-router-dom";
import { usePermissions } from "../Phase3/CheckPermission";
import AlertCard from "../components/PopUpWarning";
const GoalHierarchyForParent = () => {
  const location = useLocation();
  const { giveClientsForGuardian } = usePermissions();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const programBookId = queryParams.get("programBookId");
  const [goalBankData, setGoalBankData] = useState(null);
  const [goalAreas, setGoalAreas] = useState([]);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedGoal, setSelectedGoal] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [noProgramBook, setNoProgramBook] = useState(false);
  const [clients, setClients] = useState([]);
  const userRole = localStorage.getItem("role");
  const clientName = queryParams.get("clientName");

  const [selectedClient, setSelectedClient] = useState(null);
  useEffect(() => {
    fetchGoalBankData();
    fetchClients();
  }, []);
  useEffect(() => {
    if (programBookId && goalBankData) {
      fetchGoalHierarchy(null);
    }
  }, [programBookId, goalBankData]);
  useEffect(() => {
    if (goalBankData && selectedClient) fetchGoalHierarchy(selectedClient.id);
    if (goalBankData && ((clients && clients.length > 1) || noProgramBook))
      setLoading(false);
  }, [goalBankData, selectedClient, clients, noProgramBook]);
  const fetchClients = async () => {
    try {
      const fetchedClients = await giveClientsForGuardian();
      setClients(fetchedClients);
      console.log(fetchedClients, "clients fetched");

      if (fetchedClients.length === 1) {
        setSelectedClient(fetchedClients[0]);
        fetchGoalHierarchy(fetchedClients[0].id);
      }
    } catch (error) {
      console.error("Error fetching clients", error);
    }
  };

  const fetchGoalHierarchy = async (clientId) => {
    setLoading(true);
    const payload = programBookId ? { id: programBookId } : { clientId };

    try {
      const programBooksResponse = await axiosInstance.post(
        API_BASE_URL + "/api/getprogrambooks",
        payload
      );
      const programBooksData = programBooksResponse.data;

      if (
        !programBooksData ||
        !Array.isArray(programBooksData) ||
        programBooksData.length === 0
      ) {
        console.warn("No program book associated for the client.");
        setNoProgramBook(true);
        setLoading(false);
        return;
      }

      const goalsByArea = [];
      programBooksData.forEach((programBook) => {
        programBook.dataStrategyList.forEach((strategy) => {
          strategy.developmentalAreaList.forEach((area) => {
            area.treatmentPlanObjectiveList.forEach((objective) => {
              objective.shortTermObjective.forEach((shortTerm) => {
                shortTerm.goals.forEach((goal) => {
                  let existingArea = goalsByArea.find(
                    (area) => area.goalAreaId === goal.goalAreaId
                  );
                  if (!existingArea) {
                    existingArea = {
                      goalAreaId: goal.goalAreaId,
                      goalAreaName: goal.goalAreaName,
                      goals: [],
                    };
                    goalsByArea.push(existingArea);
                  }
                  existingArea.goals.push(goal);
                });
              });
            });
          });
        });
      });
      console.log("goal bank data", goalBankData, "goal bank");
      if (goalBankData) {
        const filteredData = filterHierarchy(goalBankData, goalsByArea);
        setCurrentFolder(filteredData);
        setBreadcrumb([
          { name: goalBankData.goalBankAreaName, node: filteredData },
        ]);
      }

      setGoalAreas(goalsByArea);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching goal hierarchy:", error);
      setNoProgramBook(true);
      setLoading(false);
    }
  };

  const fetchGoalBankData = async () => {
    try {
      const response = await axiosInstance.post(
        API_BASE_URL + "/api/getgoalbankarea",
        { id: "1" }
      );
      setGoalBankData(response.data.data);
    } catch (error) {
      console.error("Error fetching goal bank data:", error);
    }
  };

  const filterHierarchy = (node, goalAreas) => {
    if (!node) return null;
    const isRequired = goalAreas.some((area) => area.goalAreaId === node.id);
    const filteredChildren = node.children
      ? node.children
          .map((child) => filterHierarchy(child, goalAreas))
          .filter(Boolean)
      : [];
    return isRequired || filteredChildren.length > 0
      ? { ...node, children: filteredChildren }
      : null;
  };

  const navigateToFolder = (node) => {
    setCurrentFolder(node);
    const index = breadcrumb.findIndex((item) => item.node.id === node.id);
    setBreadcrumb(breadcrumb.slice(0, index + 1));
  };

  const handleFolderDoubleClick = (node) => {
    setCurrentFolder(node);
    setBreadcrumb([...breadcrumb, { name: node.goalBankAreaName, node }]);
  };
  const handleViewGoal = (goal) => {
    setSelectedGoal(goal);
    setDialogOpen(true);
  };
  const handleClientChange = (event, newValue) => {
    if (!newValue) {
      // ✅ If cleared, reset everything
      setSelectedClient(null);
      setCurrentFolder(null); // ✅ Clears the displayed folders
      setGoalAreas([]); // ✅ Clears the goals
      setBreadcrumb([]); // ✅ Clears the breadcrumb navigation
      return;
    }
    setSelectedClient(newValue);
    fetchGoalHierarchy(newValue.id);
    setNoProgramBook(false);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedGoal(null);
  };
  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <Box p={3}>
      {clientName && (
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            mb: 2,
            textAlign: "center",
          }}
        >
          Client :  {decodeURIComponent(clientName)}
        </Typography>
      )}
      {clients.length > 1 && (
        <Autocomplete
          options={clients}
          getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
          value={selectedClient}
          onChange={handleClientChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                userRole === CLIENT || userRole === CONSENT_PARTY
                  ? "Select Learner *" // ✅ For CLIENT & CONSENT_PARTY
                  : "Select Client *" // ✅ For all other users
              }
              variant="outlined"
              fullWidth
              sx={{
                ...themeStyles.autocompleteStyles,
              }}
            />
          )}
          sx={{
            width: "100%", // ✅ Full width on small screens
            maxWidth: "750px", // ✅ Prevents it from getting too large
            margin: "0 auto", // ✅ Centers it properly
            display: "flex",
            justifyContent: "center", // ✅ Ensures proper alignment
            alignItems: "center",
            marginBottom: "20px",
            "& .MuiAutocomplete-option": {
              fontSize: "1rem",
              fontWeight: "normal", // ✅ Removed bold text
            },
          }}
        />
      )}
      {noProgramBook ? (
        <AlertCard title={"Program Book"} />
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 3,
            p: 2,
            bgcolor: "#e3f2fd",
            borderRadius: 2,
          }}
        >
          {breadcrumb.map((item, index) => (
            <Box key={index} display="flex" alignItems="center">
              <Chip
                label={item.name}
                onClick={() => navigateToFolder(item.node)}
                sx={{
                  cursor: "pointer",
                  fontWeight: "bold",
                  color: "#1565c0",
                  bgcolor: "#bbdefb",
                }}
              />
              {index < breadcrumb.length - 1 && (
                <ArrowForwardIos
                  sx={{ fontSize: 12, mx: 1, color: "#1565c0" }}
                />
              )}
            </Box>
          ))}
        </Box>
      )}
      {currentFolder && (
        <Folder
          node={currentFolder}
          goalAreas={goalAreas}
          onDoubleClick={handleFolderDoubleClick}
          handleViewGoal={handleViewGoal}
        />
      )}
      <GoalDetailsDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        selectedGoal={selectedGoal}
      />
      {programBookId && (
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mt: 10, gap: 2 }}
        >
          <Button
            type="button"
            variant="contained"
            className="animated-input"
            onClick={() => navigate(-1)} // Handle Go Back button click
            sx={{
              ...buttonStyle,
            }}
          >
            GO BACK
          </Button>
        </Box>
      )}
    </Box>
  );
};

const Folder = ({ node, goalAreas, onDoubleClick, handleViewGoal }) => {
  const matchingGoals =
    goalAreas.find((area) => area.goalAreaId === node.id)?.goals || [];

  return (
    <Box>
      <Grid container spacing={2}>
        {node?.children &&
          node.children.map((child) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={child.id}>
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Card
                  sx={{ p: 2, bgcolor: "#f5f5f5", cursor: "pointer" }}
                  onDoubleClick={() => onDoubleClick(child)}
                  onClick={() => onDoubleClick(child)}
                >
                  <CardContent display="flex" alignItems="center">
                    <FolderIcon sx={{ mr: 1, color: "#3f51b5" }} />
                    <Typography variant="h6" fontWeight="bold">
                      {child.goalBankAreaName}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
      </Grid>
      {matchingGoals.length > 0 && (
        <Box
          sx={{
            width: "85%",
            mt: 4,
            ml: "auto",
            mr: "auto",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            p: 3,
          }}
        >
          <DataGrid
            initialState={{
              pagination: { paginationModel: { pageSize: 25 } }, // ✅ Default 25 rows per page
            }}
            sx={{
              ...dataGridStyle,
              "& .MuiDataGrid-footerContainer": {
                justifyContent: "space-between", // ✅ Proper alignment
                padding: "10px 20px", // ✅ Adds padding for spacing
                backgroundColor: "#3A57E8", // ✅ Matching footer background
                display: "flex", // ✅ Uses flexbox for better alignment
                alignItems: "center", // ✅ Ensures everything is centered properly
              },
              "& .MuiTablePagination-toolbar": {
                display: "flex",
                justifyContent: "space-between",
                width: "100%", // ✅ Ensure it takes full width
              },
              "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                {
                  color: "#fff", // ✅ White text for "Rows per page" and pagination details
                  fontSize: "14px", // ✅ Improve readability
                  marginBottom: "2px", // ✅ Fix slight misalignment
                  color: "#fff", // ✅ White color for pagination buttons
                },
              "& .MuiTablePagination-actions button": {
                color: "#fff", // ✅ White color for pagination buttons
              },
              "& .MuiTablePagination-root .MuiSvgIcon-root": {
                color: "#fff", // ✅ White color for dropdown icon
              },
              "& .MuiSelect-select": {
                color: "#fff !important", // ✅ Makes the dropdown text white
                fontSize: "14px !important", // ✅ Increases font size
                fontWeight: "bold", // ✅ Makes it slightly bolder for better visibility
                marginTop: "3px",
              },
              "& .MuiOutlinedInput-input": {
                color: "#fff !important", // ✅ Ensures white text inside the dropdown
              },
              "& .MuiSelect-icon": {
                color: "#fff !important", // ✅ Makes the dropdown arrow white
              },
              "& .MuiDataGrid-selectedRowCount": {
                color: "#fff !important", // ✅ Changes "1 row selected" text to white
                fontSize: "14px", // ✅ Slightly bigger for better readability
              },
            }}
            pageSizeOptions={[25, 50, 100]} // ✅ Page size options
            rows={matchingGoals.map((goal) => ({ ...goal, id: goal.id }))} // ✅ Ensure valid rows
            columns={[
              { field: "goalName", headerName: "Goal Name", width: 250 },
              {
                field: "goalDescription",
                headerName: "Description",
                width: 400,
                flex: 1,
              },
              {
                field: "view",
                headerName: "View",
                width: 100,
                renderCell: (params) => (
                  <IconButton onClick={() => handleViewGoal(params.row)}>
                    <Visibility /> {/* ✅ White icon color */}
                  </IconButton>
                ),
              },
            ]}
            autoHeight
            disableSelectionOnClick
          />
        </Box>
      )}
    </Box>
  );
};

export default GoalHierarchyForParent;
